import {
  $greetingsTableSearchInputValue,
  GreetingsTable,
  GreetingsTableGate,
  greetingsTableQuery,
} from '@/entities/greetings'
import { STRINGS } from '@/shared/config'
import { EmptyContent, HidingSpin } from '@/shared/ui'
import { greetingFormModalOpened } from '@/widgets/GreetingForm'
import { useUnit } from 'effector-react'

import {
  $settingsGreetingsPageInactiveTabLatestFilters,
  $settingsGreetingsPageInactiveTabLatestPage,
  $settingsGreetingsPageInactiveTabLatestPageSize,
  $settingsGreetingsPageInactiveTabLatestSearch,
  $settingsGreetingsPageInactiveTabLatestSort,
  SettingsGreetingsPageInactiveTabGate,
} from '../../model/settings-greetings-inactive-tab.model'

export const InactiveGreetingsTab = () => {
  const { data, pending, error } = useUnit(greetingsTableQuery)
  const latestSearch = useUnit($settingsGreetingsPageInactiveTabLatestSearch)
  const latestSort = useUnit($settingsGreetingsPageInactiveTabLatestSort)
  const latestFilters = useUnit($settingsGreetingsPageInactiveTabLatestFilters)
  const latestPage = useUnit($settingsGreetingsPageInactiveTabLatestPage)
  const latestPageSize = useUnit(
    $settingsGreetingsPageInactiveTabLatestPageSize,
  )
  const openFormModal = useUnit(greetingFormModalOpened)

  const search = useUnit($greetingsTableSearchInputValue)
  return (
    <>
      <SettingsGreetingsPageInactiveTabGate />
      <GreetingsTableGate
        initialFilters={{ ...latestFilters, IsActive: false }}
        initialPage={latestPage}
        initialPageSize={latestPageSize}
        initialSort={latestSort}
        initialSearch={latestSearch}
      />
      <HidingSpin spinning={pending || (!data?.items && !error)}>
        {data?.items && data.items.length > 0 ? (
          <GreetingsTable
            onEdit={(greetingId: string) => {
              openFormModal({ id: greetingId })
            }}
          />
        ) : search?.length && search?.length > 0 ? (
          <EmptyContent description={STRINGS.nothing_was_found} />
        ) : (
          <EmptyContent description="В списке пока нет ни одного приветственного экрана" />
        )}
      </HidingSpin>
    </>
  )
}
